import { createApi } from '@reduxjs/toolkit/query/react';

import {
  GetRoleRequestSchemaType,
  GetRoleResponseSchemaType,
  UserRoleSchemaType,
} from 'src/global/schemas/role.schema';

import { REDUX_SLICE } from '../constants';
import { axiosBaseQuery } from '../utils';

export const roleApi = createApi({
  reducerPath: REDUX_SLICE.ROLE_API,
  baseQuery: axiosBaseQuery,
  endpoints: builder => ({
    getUserRole: builder.query<UserRoleSchemaType, GetRoleRequestSchemaType>({
      query: arg => ({
        method: 'GET',
        path: '/v1/roles',
        headers: {
          'x-offchain-address': arg.address,
        },
      }),
      transformResponse: (returnValue: GetRoleResponseSchemaType) => returnValue.data,
    }),
  }),
});

export const { useGetUserRoleQuery } = roleApi;
